var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 21,
    viewBox: "0 0 105 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M0 0h54.564v20.103H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.78 17.23v-2.42H8.12V5.293h6.66V2.872H5.742V17.23h9.036zM26.083 17.23V2.873h-9.425V17.23h9.425zm-7.05-11.937h4.674v9.517h-4.674V5.293zM37.925 17.23V8.633l-4.947-5.76h-4.946V17.23h9.893zM30.408 5.335h1.557l3.662 4.342v5.092h-5.22V5.334zM48.82 17.23v-2.42h-6.66v-3.507h6.66v-2.42h-6.66v-3.59h6.66V2.872h-9.035V17.23h9.035z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.07 17.506V6.008h4.14V3.676H57.437v2.332h4.181v11.498h2.453zM80.77 17.506V3.676h-2.453v5.79h-5.629v-5.79h-2.453v13.83h2.453v-5.709h5.629v5.71h2.452zM92.206 17.506V7.053l-4.664-4.181-4.664 4.261v10.373h2.453v-5.709h4.422v5.71h2.453zM87.542 6.088l2.211 2.01v1.367h-4.422V8.098l2.21-2.01zM100.859 17.506V6.008H105V3.676H94.225v2.332h4.181v11.498h2.453z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a003d7a362e761f0e2cd4ac2becadaaf.svg";
export { ForwardRef as ReactComponent };